module.exports = __webpack_public_path__ + "assets/e276a75583f9abfd668c72bc5e1cdeb0.mp4";